import React from 'react'
import heroImg from '../assets/images/heroImg.jpg'
import pattern from '../assets/images/pattern.png'
import mountain from '../assets/svgs/layered-peaks-haikei.svg'


import HeroSection from '../components/HeroSection'
import ClientsSection from '../components/ClientsSection'
import StackSection from '../components/StackSection'
import HireSection from '../components/HireSection'
import ServicesSection from '../components/ServicesSection'
import ProcessSection from '../components/ProcessSection'
import ConsultantSection from '../components/ConsultantSection'
import IndustrySection from '../components/IndustrySection'
import QuoteSection from '../components/QuoteSection'
import BrandingSection from '../components/BrandingSection'
import EngagementSection from '../components/EngagementSection'
import ProjectSection from '../components/ProjectSection'
const Home = () => {
  return (
    <div>
        {/* <div style={{'backgroundImage':`url(${heroImg})`}}  className='h-auto flex flex-col'> */}
        <div className='h-auto  flex flex-col mt-20'>
        <div className='p-5 max-w-6xl 2xl:max-w-7xl mx-auto '>
        <HeroSection/>
       </div>
       <svg
      id="wave"
      className={`w-full h-auto`}
      style={{ transform: "rotate(0deg)", transition: "0.3s" }}
      viewBox="0 0 4937 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="sw-gradient-0" x1="0" x2="0" y1="1" y2="0">
          <stop stopColor="rgba(243, 244, 245, 1)" offset="0%" />
          <stop stopColor="rgba(243, 244, 245, 1)" offset="100%" />
        </linearGradient>
      </defs>
      <path
        style={{ transform: "translate(0, 0px)", opacity: 1 }}
        fill="url(#sw-gradient-0)"
        d="M0,0L34.3,0C68.6,0,137,0,206,8.3C274.3,17,343,33,411,35C480,37,549,23,617,15C685.7,7,754,3,823,8.3C891.4,13,960,27,1029,41.7C1097.1,57,1166,73,1234,66.7C1302.9,60,1371,30,1440,21.7C1508.6,13,1577,27,1646,33.3C1714.3,40,1783,40,1851,48.3C1920,57,1989,73,2057,81.7C2125.7,90,2194,90,2263,90C2331.4,90,2400,90,2469,75C2537.1,60,2606,30,2674,30C2742.9,30,2811,60,2880,71.7C2948.6,83,3017,77,3086,71.7C3154.3,67,3223,63,3291,61.7C3360,60,3429,60,3497,53.3C3565.7,47,3634,33,3703,35C3771.4,37,3840,53,3909,65C3977.1,77,4046,83,4114,85C4182.9,87,4251,83,4320,81.7C4388.6,80,4457,80,4526,81.7C4594.3,83,4663,87,4731,83.3C4800,80,4869,70,4903,65L4937.1,60L4937.1,100L4902.9,100C4868.6,100,4800,100,4731,100C4662.9,100,4594,100,4526,100C4457.1,100,4389,100,4320,100C4251.4,100,4183,100,4114,100C4045.7,100,3977,100,3909,100C3840,100,3771,100,3703,100C3634.3,100,3566,100,3497,100C3428.6,100,3360,100,3291,100C3222.9,100,3154,100,3086,100C3017.1,100,2949,100,2880,100C2811.4,100,2743,100,2674,100C2605.7,100,2537,100,2469,100C2400,100,2331,100,2263,100C2194.3,100,2126,100,2057,100C1988.6,100,1920,100,1851,100C1782.9,100,1714,100,1646,100C1577.1,100,1509,100,1440,100C1371.4,100,1303,100,1234,100C1165.7,100,1097,100,1029,100C960,100,891,100,823,100C754.3,100,686,100,617,100C548.6,100,480,100,411,100C342.9,100,274,100,206,100C137.1,100,69,100,34,100L0,100Z"
      ></path>
    </svg>
        </div>
        <div className='p-5 md:p-8 bg-gray-100'>
        <ClientsSection/>
        </div>
        <svg
      id="wave"
      className={`w-full h-auto`}
      style={{ transform: "rotate(180deg)", transition: "0.3s" }}
      viewBox="0 0 4937 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="sw-gradient-0" x1="0" x2="0" y1="1" y2="0">
          <stop stopColor="rgba(243, 244, 245, 1)" offset="0%" />
          <stop stopColor="rgba(243, 244, 245, 1)" offset="100%" />
        </linearGradient>
      </defs>
      <path
        style={{ transform: "translate(0, 0px)", opacity: 1 }}
        fill="url(#sw-gradient-0)"
        d="M0,10L34.3,18.3C68.6,27,137,43,206,55C274.3,67,343,73,411,75C480,77,549,73,617,65C685.7,57,754,43,823,33.3C891.4,23,960,17,1029,18.3C1097.1,20,1166,30,1234,31.7C1302.9,33,1371,27,1440,23.3C1508.6,20,1577,20,1646,28.3C1714.3,37,1783,53,1851,56.7C1920,60,1989,50,2057,40C2125.7,30,2194,20,2263,23.3C2331.4,27,2400,43,2469,55C2537.1,67,2606,73,2674,71.7C2742.9,70,2811,60,2880,50C2948.6,40,3017,30,3086,26.7C3154.3,23,3223,27,3291,36.7C3360,47,3429,63,3497,73.3C3565.7,83,3634,87,3703,75C3771.4,63,3840,37,3909,23.3C3977.1,10,4046,10,4114,10C4182.9,10,4251,10,4320,13.3C4388.6,17,4457,23,4526,28.3C4594.3,33,4663,37,4731,31.7C4800,27,4869,13,4903,6.7L4937.1,0L4937.1,100L4902.9,100C4868.6,100,4800,100,4731,100C4662.9,100,4594,100,4526,100C4457.1,100,4389,100,4320,100C4251.4,100,4183,100,4114,100C4045.7,100,3977,100,3909,100C3840,100,3771,100,3703,100C3634.3,100,3566,100,3497,100C3428.6,100,3360,100,3291,100C3222.9,100,3154,100,3086,100C3017.1,100,2949,100,2880,100C2811.4,100,2743,100,2674,100C2605.7,100,2537,100,2469,100C2400,100,2331,100,2263,100C2194.3,100,2126,100,2057,100C1988.6,100,1920,100,1851,100C1782.9,100,1714,100,1646,100C1577.1,100,1509,100,1440,100C1371.4,100,1303,100,1234,100C1165.7,100,1097,100,1029,100C960,100,891,100,823,100C754.3,100,686,100,617,100C548.6,100,480,100,411,100C342.9,100,274,100,206,100C137.1,100,69,100,34,100L0,100Z"
      ></path>
    </svg>
       <div className='w-full bg-white p-5 md:p-20'>
       <StackSection/>
       </div>
       <div>
       {/* <HireSection/> */}
       <img src={pattern} alt="" />
       </div>
       <div className='w-full bg-[#F6FCFF] p-5 lg:p-20'>
       <ServicesSection/>
       </div>
       <img src={pattern} alt="" />
       <div className='w-full  p-5 lg:p-20'>
       <ProcessSection/>
       </div>
       <div className='w-full  p-5 lg:p-20'>
       <ProjectSection/>
       </div>
       <div className='w-full  p-5 lg:p-20'>
       <EngagementSection/>
       </div>
              <svg
      id="wave"
      className={`w-full h-auto`}
      style={{ transform: "rotate(0deg)", transition: "0.3s" }}
      viewBox="0 0 4937 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="sw-gradient-0" x1="0" x2="0" y1="1" y2="0">
          <stop stopColor="rgba(243, 244, 245, 1)" offset="0%" />
          <stop stopColor="rgba(243, 244, 245, 1)" offset="100%" />
        </linearGradient>
      </defs>
      <path
        style={{ transform: "translate(0, 0px)", opacity: 1 }}
        fill="url(#sw-gradient-0)"
        d="M0,0L34.3,0C68.6,0,137,0,206,8.3C274.3,17,343,33,411,35C480,37,549,23,617,15C685.7,7,754,3,823,8.3C891.4,13,960,27,1029,41.7C1097.1,57,1166,73,1234,66.7C1302.9,60,1371,30,1440,21.7C1508.6,13,1577,27,1646,33.3C1714.3,40,1783,40,1851,48.3C1920,57,1989,73,2057,81.7C2125.7,90,2194,90,2263,90C2331.4,90,2400,90,2469,75C2537.1,60,2606,30,2674,30C2742.9,30,2811,60,2880,71.7C2948.6,83,3017,77,3086,71.7C3154.3,67,3223,63,3291,61.7C3360,60,3429,60,3497,53.3C3565.7,47,3634,33,3703,35C3771.4,37,3840,53,3909,65C3977.1,77,4046,83,4114,85C4182.9,87,4251,83,4320,81.7C4388.6,80,4457,80,4526,81.7C4594.3,83,4663,87,4731,83.3C4800,80,4869,70,4903,65L4937.1,60L4937.1,100L4902.9,100C4868.6,100,4800,100,4731,100C4662.9,100,4594,100,4526,100C4457.1,100,4389,100,4320,100C4251.4,100,4183,100,4114,100C4045.7,100,3977,100,3909,100C3840,100,3771,100,3703,100C3634.3,100,3566,100,3497,100C3428.6,100,3360,100,3291,100C3222.9,100,3154,100,3086,100C3017.1,100,2949,100,2880,100C2811.4,100,2743,100,2674,100C2605.7,100,2537,100,2469,100C2400,100,2331,100,2263,100C2194.3,100,2126,100,2057,100C1988.6,100,1920,100,1851,100C1782.9,100,1714,100,1646,100C1577.1,100,1509,100,1440,100C1371.4,100,1303,100,1234,100C1165.7,100,1097,100,1029,100C960,100,891,100,823,100C754.3,100,686,100,617,100C548.6,100,480,100,411,100C342.9,100,274,100,206,100C137.1,100,69,100,34,100L0,100Z"
      ></path>
    </svg>
       <div className='w-full p-5 lg:pb-20 bg-gray-100'>
       <IndustrySection/>
       </div>
       {/* <QuoteSection/> */}
       {/* <BrandingSection/> */}
    </div>
  )
}
export default Home